import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-card',
  templateUrl: './confirm-delete-card.component.html',
  styleUrls: ['./confirm-delete-card.component.scss']
})
export class ConfirmDeleteCardComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public cardNumber: string,
    private matDialogRef: MatDialogRef<ConfirmDeleteCardComponent>
  ) { }

  ngOnInit(): void {
  }

  delete(): void {
    this.matDialogRef.close(true);
  }
}
